document.addEventListener("DOMContentLoaded", function() {
  // Function to update media based on the selected variant
  function updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    // Get the media ID for the selected variant
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;

    // Get the parent element and prepend the new media
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);

    // Smooth scroll the parent container to the top
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  // Listen for variant selection changes (either dropdown or swatches)
  const variantSelectors = document.querySelectorAll('.product-variants .variant-select, .swatch-element');
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', function() {
      // Assuming currentVariant is available in the global scope after variant selection
      updateMedia.call(this);
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
    const applyButton = document.querySelector(".cd-discount-button");
    const discountInput = document.querySelector(".discount-input");

    applyButton.addEventListener("click", () => {
        const discountCode = discountInput.value.trim();

        if (!discountCode) {
            alert("Please enter a coupon code.");
            return;
        }

        // Redirect to the cart page with the discount code applied
        window.location.href = `/cart?discount=${discountCode}`;
    });
});


 function toggleContent(sectionId) {
    const content = document.getElementById(sectionId);
    content.classList.toggle("open");

    const header = content.previousElementSibling; // Get the associated header
    const arrow = header.querySelector(".arrow");
    arrow.style.transform = content.classList.contains("open")
        ? "rotate(-135deg)" // Rotate up
        : "rotate(45deg)";  // Rotate down
}



